export const SET_MAINTENANCE_SETTINGS = "maintenance/SET_MAINTENANCE_SETINGS";